// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2519": "928e2bfa6126","5336": "5083bc5218c4","5803": "903432f2970c","6708": "f3dda82578bc","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}